import axios from './index'
import prefix_ms from './prefix'

// 通过code获取用户信息
export const loginByCode = (code) => {
  return axios.request({
    url: `${prefix_ms}/login/weixin/officialAccount`,
    method: 'post',
    data: {code},
  })
}

export const testToken = (code = 9) => {
  return axios.request({
    url: `${prefix_ms}/swagger/token`,
    method: 'get',
    params: {userId: code},
  })
}

//获取用户信息
export const getInfo = () => {
  return axios.request({
    url: `${prefix_ms}/user/info`,
    method: 'get',
  })
}

// /user/child/finish
// 获取已完成今日打卡的孩子列表
export const getFinish = (params) => {

  return axios.request({
    url: `${prefix_ms}/user/child/finish`,
    method: 'get',
    params: params,
  })
}


//微信网页签名信息
export const getWeixinParams = (params) => {
  return axios.request({
    url: `${prefix_ms}/weixin/jsapi/config`,
    method: 'get',
    params: params,
  })
}

//判断用户是否关注公众号
export const getIsFollowThePublic = () => {
  return axios.request({
    url: `${prefix_ms}/user/checkUserIsOfficialAccounts`,
    method: 'get',
  })
}


//我的购买
export const groupBuyOrderpaid = (params) => {
  return axios.request({
    url: `${prefix_ms}/groupBuyOrder/list/paid`,
    method: 'post',
    params: params,
  })
}

//获取用户积分兑换记录
export const rewardPointGoodsHistory = (params) => {
  return axios.request({
    url: `${prefix_ms}/userRewardPointHis/exchange/history`,
    method: 'get',
    params: params,
  })
}

export const rewardPointGoodsExchange = (params) => {
  return axios.request({
    url: `${prefix_ms}/rewardPointGoods/exchange`,
    method: 'post',
    data: params,
  })
}

///swagger/user/qrcode
// 获取用户二维码
export const getQrcode = () => {
  return axios.request({
    url: `${prefix_ms}/user/qrcode`,
    method: 'get',
  })
}

// /user/qrcode/recognize
// 识别用户二维码
export const getRecognize = (params) => {
  return axios.request({
    url: `${prefix_ms}/user/qrcode/recognize`,
    method: 'get',
    params: params,
  })
}

// /user/bind
// 亲子关系绑定
export const postBind = (params) => {
  return axios.request({
    url: `${prefix_ms}/user/bind`,
    method: 'post',
    data: params,
  })
}

// /user/family
// 获取亲子列表
export const getFamily = (params) => {
  return axios.request({
    url: `${prefix_ms}/user/family`,
    method: 'get',
    params: params,
  })
}

// /user/unbind/{childId}
// 家长解绑
export const postUnbinUd = (childId) => {
  return axios.request({
    url: `${prefix_ms}/user/unbind/${childId}`,
    method: 'post',
  })
}

// /user/family
// 获取亲子列表
export const getFavoriteCount = () => {
  return axios.request({
    url: `${prefix_ms}/userArticleFavorite/count`,
    method: 'get',
  })
}




//////////////////
// WEBPACK FOOTER
// ./app/api/user.js
// module id = null
// module chunks = 